import { OfferIcon } from '@/components/svg/offer-icon/offer-icon'
import cx from 'classnames'
import s from './offers-badge.module.scss'

type Props = {
  className?: string
}

export const OffersBadge = ({ className }: Props) => {
  return (
    <span className={cx(s.offersBadge, className)}>
      <OfferIcon
        iconColor="#f68a5b"
        svgProps={{ 'aria-hidden': true, focusable: false }}
      />
      Offers Available
    </span>
  )
}
